export default "__VITE_ASSET__CbZyxtVq__"